<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <v-btn-toggle
          group
          tile
          color="indigo lighten-2 accent-3"
          v-model="buttonSelected"
        >
          <v-btn @click="showHolidayGroup">{{
            $tc("holidayGroups.holidayGroups")
          }}</v-btn>
          <v-btn @click="showHolidays">{{ $tc("holidays.holidays") }}</v-btn>
        </v-btn-toggle>
        <ToolbarTitles />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="buttonSelected === 0" class="container">
        <HolidayGroups :showCard="showCard" />
      </div>
      <div v-else-if="buttonSelected === 1" class="container">
        <Holidays :showCard="showCard" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import HolidayGroups from "./GruposFeriados/HolidaysGroups.vue";
import Loader from "@/components/Complement/Loader.vue";
import Holidays from "./Feriados/Forms/Holidays.vue";
import holidaysGroups from "@/store/gruposDeFeriados/holidaysGroups";
export default {
  components: {
    Holidays,
    HolidayGroups,
    Loader,
    ToolbarTitles,
    ButtonsCardList,
  },
  data() {
    return {
      buttonSelected: 0,
      isLoading: true,
      showCard: true,
    };
  },
  computed: {
    padding() {
      return holidaysGroups.state.paddingNav;
    },
  },
  methods: {
    cardView(value) {
      this.showCard = value;
    },
    showHolidayGroup() {
      this.isLoading = true;
      this.$nextTick(() => {
        this.buttonSelected = 0;
        this.isLoading = false;
      });
    },
    showHolidays() {
      this.isLoading = true;
      this.$nextTick(() => {
        this.buttonSelected = 1;
        this.isLoading = false;
      });
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
